<template>
    <div class="map-details">
        <div class="header clearfix">
            <div class="back left" @click="goback()" v-show="!isFromMap||resultlistShow">
                <i class="iconfont icon-fanhui"></i>
                <span>返回</span>
            </div>
            <div class="close right" @click="close()" v-show="!resultlistShow">
                <i class="iconfont icon-guanbi"></i>
           </div>
        </div>
        <div class="details-scroll">
            <el-scrollbar style="height: 100%;width: 100%;">
                <div class="details">
                    <div class="map-img">
                       <!--  <img src="@/assets/images/mapView/video6.png" alt=""/> -->
                        <div v-show="qjtShow" style="width: 100%;height: 100%;" id="map-img">
                             <photosphereviewer v-if="photosphereviewerFlag" :tableImgHeight="'160px'" :landinfo ="landinfo" ></photosphereviewer>
                        </div>
                        <div v-show="!qjtShow" class="no-data">
                            <i class="iconfont icon-zanwutupian"></i>
                        </div>
                        <div class="title">{{feature.properties.dkmc}}</div>
                       <!--  <el-button  type="primary" plain style="position: absolute;top: 5px;right: 5px;z-index: 50;" @click="expand">全屏</el-button> -->
                        <div v-show="qjtShow" class="img-button" @click="expand">
                           <i class="iconfont icon-quanping"></i>
                        </div>
                      <!--   <div v-show="!qjtShow" style="cursor: not-allowed;" class="img-button">
                            <i class="iconfont icon-quanping"></i>
                        </div> -->
                    </div>
                    <div class="location-area clearfix">
                        <div class="left location">
                            <i class="iconfont icon-dingwei"></i>
                            <span>{{feature.properties.dkdz}}</span>
                        </div>
                        <div class="right area"  @click="zoomIn()">
                           <!--  <i class="iconfont icon-mianji"></i>
                            <span>面积：<span class="num">{{dkmj}}</span>亩</span> -->
                             <i style="color:#056cf7;cursor: pointer;" class="iconfont icon-dingwei"></i>
                            <span style="margin-right: 10px;text-decoration: underline;cursor: pointer;color: #056cf7">定位地块</span>
                        </div>
                    </div>
                    <div class="information">
                        <el-row>
                            <el-col :span="12">
                                <span>行政区</span>
                                <span>{{feature.properties.xzqmc}}</span>
                            </el-col>
                            <el-col :span="12">
                                <span>地块面积</span>
                                <span>{{feature.properties.dkmj}}亩</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span>土地用途</span>
                                  <el-tooltip class="item" effect="dark" :content="feature.properties.tdyt" placement="top">
                                    <span>{{feature.properties.tdyt}}</span>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="12">
                                <span>容积率</span>
                                <span>{{feature.properties.rjl}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span>拟供地方式</span>
                                <span>{{feature.properties.gdfs}}</span>
                            </el-col>
                            <el-col :span="12">
                                <span>拟供地时间</span>
                                <span>{{feature.properties.gdDate?feature.properties.gdDate:"-"}}</span>
                            </el-col>
                        </el-row>
                     <!--    <el-row>
                            <el-col :span="12">
                                <span>是否标准地</span>
                                <span>{{feature.properties.sfbzd?"":"-"}}</span>
                            </el-col>
                            <el-col :span="12">
                                <span>工业园区</span>
                                <span>{{feature.properties.sfbzd?"":"-"}}</span>
                            </el-col>
                        </el-row> -->
                    </div>
                    <div class="contact clearfix">
                        <div class="left photo">
                            <img src="@/assets/images/mapView/DefTX.png" alt=""/>
                        </div>
                        <div class="contact-information">
                            <div class="name">
                                <span>联系人</span>
                                <span>{{feature.properties.lxr?feature.properties.lxr:"-"}}</span>
                            </div>
                            <div class="iphone">
                                <span>联系电话</span>
                                <span>{{feature.properties.lxdh?feature.properties.lxdh:"-"}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="land-code">
                    <div class="title">
                        <span>专属土地码</span>
                    </div>
                    <div class="code">
                        <img :src="ewmUlr" alt=""/>
                    </div>
                </div>
            </el-scrollbar>
            <div class="entrance">
                <div @mouseover="entranceMouseover('moreDetails')" @mouseleave="entranceMouseleave" @click="moreDetails">
                    <svg v-show="entranceIcon !== 'moreDetails'" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-gengduoxiangqing"></use>
                    </svg>
                    <i v-show="entranceIcon === 'moreDetails'" class="iconfont icon-gengduoxiangqing"></i>
                    <div>更多详情</div>
                </div>
                <div @mouseover="entranceMouseover('searchAround')" @mouseleave="entranceMouseleave" @click="searchAround">
                    <svg v-show="entranceIcon !== 'searchAround'" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-zhoubiansousuo"></use>
                    </svg>
                    <i v-show="entranceIcon === 'searchAround'"  class="iconfont icon-zhoubiansousuo"></i>
                    <div>周边搜索</div>
                </div>
                <div @mouseover="entranceMouseover('plotContrastList')" @mouseleave="entranceMouseleave" @click="plotContrastList">
                    <svg v-show="entranceIcon !== 'plotContrastList'" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-tianjiaduibi"></use>
                    </svg>
                    <i v-show="entranceIcon === 'plotContrastList'" class="iconfont icon-tianjiaduibi"></i>
                    <div>添加对比</div>
                </div>
                  <div @mouseover="entranceMouseover('commonProblem')" @mouseleave="entranceMouseleave" @click="commonProblem">
                    <svg v-show="entranceIcon !== 'commonProblem'" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-changjianwenti"></use>
                    </svg>
                    <i v-show="entranceIcon === 'commonProblem'" class="iconfont icon-changjianwenti"></i>
                    <div>常见问题</div>
                </div>
            </div>
        </div>
        <div id="map-expand" class="map-expand" v-if="mapExpand" ref="mapExpand">
            <div class="title">
                <span>{{feature.properties.dkmc}}</span>
                <span class="time">全景示意图拍摄时间：{{landinfo.qjtpsDate}}</span>
            </div>
            <div class="narrow" @click="narrowClick">
                <i class="iconfont icon-guanbi"></i>
            </div>
             <photosphereviewer v-if="photosphereviewerFlag" :tableImgHeight="parentclientHeight" :showphotespheremarker="true" :navbarStatusArray="navbarStatusArray" :landinfo ="landinfo" ></photosphereviewer>
        </div>
    </div>
</template>
<script>

import {mapResourceApi} from '@/api/mapResourceApi'
import bus from '@/components/common/bus'
import QRCode from 'qrcode'
import {mapmanager, xzqUtils} from '@/views/class/mapmanager'
import photosphereviewer from 'components/main-map/photosphereviewer'
import { Notification } from 'element-ui'
export default {
  components: {
    photosphereviewer
  },
  data() {
    return {
      navbarStatusArray: ['fullscreen'],
      ewmUlr: require('@/assets/images/mapView/ewm.png'),
      initView: false,
      resultlistShow: false,
      mapExpand: false,
      feature: {
        properties: {}
      },
      landinfoData: {},
      landinfo: {},
      photespheremarkerlist: [],
      isFromMap: false, // 是否来源地图点击事件
      myViewer: '',
      maxviewer: '',
      dkmj: 0,
      dkmj_pfm: 0,
      /*   imgurl3: require('@/assets/images/mapView/mapview3.jpg'),
      imgurl2: require('@/assets/images/mapView/mapview2.jpg'),
      imgurl1: require('@/assets/images/mapView/mapview.jpg'), */
      imgurl1: require('@/assets/ewm/455d937a19ce487ba74ea13d9a75a7c9.png'),
      imgurl2: require('@/assets/ewm/693ad816f18d454b89d8c8c5d10bf4e6.png'),
      imgurl3: require('@/assets/ewm/261afc882ec14bd8bebc9e35a675259d.png'),
      commonProblemShow: false,
      problemList: [{
        title: '如何查看预供地块？',
        answer: '可以通过点击地图地块图标和搜索功能查看相关的地块'
      }, {
        title: '是否查看各行政区预供地块？',
        answer: '通过按行政区搜索查看'
      }],
      entranceIcon: '',
      qjtShow: false,
      parentclientHeight: document.documentElement.clientHeight - 80 - 59 + 'px',
      photosphereviewerFlag: true
    }
  },
  created() {
    //
    // console.log(document.documentElement.clientHeight)
    // console.log(this.parentclientHeight)
  },
  mounted() {
  //
    /*  const h = this.$refs.mapExpand.clientHeight
    console.log(h)
    this.parentclientHeight = h + 'px'
    console.log(this.parentclientHeight) */
  },
  methods: {
    getEwm() {
      debugger
      const _this = this
      const localhostPaht = window.document.location.origin
      const url = localhostPaht + '/mobileMoreDetails/' + this.feature.properties.id
      console.log(this.feature.properties.id)
      if (this.feature.properties.id === '455d937a19ce487ba74ea13d9a75a7c9') {
        _this.ewmUlr = this.imgurl1
      } else if (this.feature.properties.id === '693ad816f18d454b89d8c8c5d10bf4e6') {
        _this.ewmUlr = this.imgurl2
      } else if (this.feature.properties.id === '261afc882ec14bd8bebc9e35a675259d') {
        _this.ewmUlr = this.imgurl3
      } else {
        QRCode.toDataURL(url)
          .then(url => {
            _this.ewmUlr = url
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    getDetail(dkid) {
      const _this = this
      const params = {
        id: dkid
      }
      mapResourceApi.getLandInfoAndMatchingById(params).then(response => {
        if (response.code !== '200') {
          Notification.warning({
            title: '警告',
            message: '加载全景图周边数据出错...',
            type: 'warning'
          })
          return
        }
        if (response && response.code === '200' && response.data) {
          this.landinfoData = response.data
          this.landinfo = response.data.landinfo
          if (this.landinfo.ghfj && this.landinfo.ghfj != '') {
            _this.ewmUlr = `${gisserverUrl}` + this.landinfo.ghfj
          } else {
            _this.getEwm()
          }
          this.landinfo.photespheremarkerlist = response.data.photespheremarkerlist
          this.list = response.data.list
          this.photespheremarkerlist = response.data.photespheremarkerlist
        } else {
          Notification.warning({
            title: '警告',
            message: '加载更多详情数据出错...',
            type: 'warning'
          })
        }
      })
    },
    settingData(feature, isFromMap, resultlistShow) {
      try {
        if (this.feature && this.feature.properties.id === feature.properties.id) {
          return
        }
      } catch {

      }

      this.photosphereviewerFlag = false
      this.feature = null
      this.isFromMap = isFromMap // 是否来源于地图点击，显示详情
      this.resultlistShow = resultlistShow // 查询列表是否已经存在
      feature.properties.ydxzmc = mapmanager.getYdxzName(feature.properties.ydxz)
      feature.properties.xzqmc = xzqUtils.getXZQNAME(feature.properties.xzq)
      this.landinfo = feature.properties
      this.feature = feature
      const mj = feature.properties.dkmj * 0.0015
      this.dkmj = mj.toFixed(2)
      this.dkmj_pfm = feature.properties.dkmj.toFixed(2)
      this.getDetail(this.feature.properties.id)
      this.initPhotosphereviewer(feature.properties.qjt)
    },
    initPhotosphereviewer(qjt) {
      if (qjt) {
        this.qjtShow = true
        this.photosphereviewerFlag = true
      } else {
        this.qjtShow = false
        this.photosphereviewerFlag = false
      }
    },
    zoomIn() {
      mapmanager.zooomIn(this.feature)
    },
    // 返回
    goback() {
      this.$parent.componentShow = 'mapSearchResultsList'
      this.mapExpand = false
      this.initView = false
      bus.$emit('goback')
      if (this.resultlistShow) {
        bus.$emit('searchClear', this.resultlistShow)
      }
      mapmanager.markerSelectedHandler(this.feature.index, false)
    },
    close() {
      this.$parent.$parent.$refs.search.searchClear(this.resultlistShow)
      this.$parent.componentShow = ''
      this.initView = false
      // this.mapExpand = false
    },
    // 地块扩大
    expand() {
      const _this = this
      this.mapExpand = true
    },
    // 地块缩小
    narrowClick() {
      this.mapExpand = false
    },
    // 跳转更多详情
    moreDetails() {
      if (this.feature) {
        const dkid = this.feature.properties.id
        this.$router.push(
          {name: 'mapMoreDetails', params: {id: dkid}}
        )
      }
    },
    // 打开搜索周边
    searchAround() {
      this.$parent.componentShow = 'mapSearchAround'
      this.$parent.$refs.refsearchAround.mapSearchAround(this.feature)
    },
    // 常见问题
    commonProblem() {
      this.$parent.commonProblemShow = true
    },
    // 地块对比
    plotContrastList() {
      this.$parent.plotContrastListShow = true
      this.$parent.$refs.refplotContrastList.addContrast(this.landinfo)
    },
    entranceMouseover(data) {
      this.entranceIcon = data
    },
    entranceMouseleave() {
      this.entranceIcon = ''
    }
  },
  activated() {
    this.photosphereviewerFlag = false
    setTimeout(() => {
      this.photosphereviewerFlag = true
      mapmanager.map.invalidateSize(true)
    }, 300)
  }
}
</script>
<style lang="scss" scoped>
    .map-details{
        height: 100%;
        width: 100%;
        .header{
            height: 44px;
            padding: 10px;
            border-bottom: 1px solid #dedede;
            .back{
                height: 24px;
                background: #4293f4;
                border-radius: 4px;
                font-size: 14px;
                color: #ffffff;
                cursor: pointer;
                line-height: 24px;
                padding: 0px 8px;
                i.iconfont{
                    font-size: 14px;
                }
            }
            .close{
                line-height: 24px;
                cursor: pointer;
                i.iconfont{
                    font-size: 14px;
                }
            }
        }
        .details-scroll{
            height: calc(100% - 144px);
            width: 100%;
            .details{
                padding: 10px;
                text-align: left;
                border-bottom: 5px solid #f7f8fa;
                .map-img{
                    height: 160px;
                    position: relative;
                    width: 100%;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .title{
                        position: absolute;
                        bottom: 0px;
                        height: 40px;
                        background: rgba(51,51,51,0.40);
                        padding: 0px 10px;
                        line-height: 40px;
                        font-size: 14px;
                        font-weight: bold;
                        color: #ffffff;
                        width: 100%;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                        z-index: 9;
                    }
                    .img-button{
                        width: 28px;
                        height: 28px;
                        background: rgba(0,0,0,0.5);
                        border-radius: 50%;
                        position: absolute;
                        top: 12px;
                        right: 12px;
                        text-align: center;
                        line-height: 28px;
                        z-index: 998;
                        cursor: pointer;
                        i.iconfont{
                            font-size: 14px;
                            color: #fff;
                        }
                    }
                    .no-data{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #F2F5F6;
                        border-radius: 4px;
                        i.iconfont{
                            color: #D0DCE5;
                            font-size: 56px;
                            text-align: center;
                        }
                    }
                }
                .location-area{
                    margin: 10px 0px 5px;
                    font-size: 14px;
                    color: #666666;
                    .num{
                        color: #CC0101;
                    }
                    i.iconfont{
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }
                .information{
                    background: #fafafa;
                    padding: 10px;
                    font-size: 14px;
                    span{
                        &:first-child{
                            color: #999999;
                            width: 72px;
                            display: inline-block;
                            margin-right: 7px;
                            text-align: right;
                            line-height: 20px;
                            vertical-align: middle;
                        }
                        &:last-child{
                            color: #333;
                            width: calc(100% - 80px);
                            display: inline-block;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                            vertical-align: middle;
                            line-height: 24px;
                        }
                    }
                }
                .contact{
                    padding: 10px 10px 0px;
                    .photo{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 8px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .contact-information{
                        span{
                            &:first-child{
                                color: #999999;
                                width: 54px;
                                display: inline-block;
                                margin-right: 7px;
                                text-align: right;
                                line-height: 20px;
                            }
                            &:last-child{
                                color: #333;
                                display: inline-block;
                                line-height: 20px;
                            }
                        }
                    }
                }
            }
            .land-code{
                height: calc(100vh - 60px - 130px - 44px - 485px - 10px);
                min-height: 161px;
                .title{
                    height: 44px;
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    padding-top: 12px;
                    border-bottom: 1px solid #dedede;
                    span{
                        display: inline-block;
                        padding-left: 15px;
                        border-left: 3px solid #649AFC;
                        height: 20px;
                    }
                }
                .code{
                    height: calc(100% - 44px);
                    padding: 2px 0px;
                    img{
                        width: 120px;
                        height: 118px;
                    }
                }
            }
            .entrance{
                border-top: 1px solid #dedede;
                height: 100px;
                padding: 10px 10px 0px;
                display: flex;
                justify-content: space-between;
                >div{
                    width: calc((100% - 30px) / 4);
                    margin-right: 10px;
                    background: #f8f8f8;
                    font-size: 14px;
                    color: #333333;
                    padding-top: 21px;
                    cursor: pointer;
                    .icon{
                        width: 2em;
                        height: 2em;
                    }
                    i.iconfont{
                        font-size: 28px;
                        vertical-align: -0.15em;
                        fill: currentColor;
                        overflow: hidden;
                    }
                    &:hover{
                        background: #2f80ed;
                        color: #fff;
                    }
                }
            }
            ::v-deep{
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
        }
        .map-expand{
            position: fixed;
            width: calc(100% - 530px);
            left: 520px;
            top: 80px;
            height: calc(100% - 80px - 60px);
            background: #fff;
            border-radius: 4px;
            overflow: hidden;
            z-index: 997;
            .title{
                position: absolute;
                top: 12px;
                left: 10px;
                background: rgba(0,0,0,0.5);
                padding:6px 10px;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                font-weight: bold;
                z-index: 10;
                .time{
                    margin-left: 20px;
                }
            }
            .narrow{
                width: 28px;
                height: 28px;
                background: rgba(0,0,0,0.5);
                border-radius: 50%;
                position: absolute;
                top: 12px;
                right: 12px;
                text-align: center;
                line-height: 28px;
                cursor: pointer;
                z-index: 998;
                i.iconfont{
                    font-size: 14px;
                    color: #fff;
                }
            }
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
